import { ParsedUrlQuery } from 'querystring';

/**
 * Retrieve value from url query.
 * When there are values of same key, it falls back to the first value.
 * when takeLast is true, it retrieves the last value from multiple values
 * */
export const retrieveValueFromUrlQuery = ({
  query,
  paramKey,
  takeLast = false,
}: {
  query: ParsedUrlQuery;
  paramKey: string;
  takeLast?: boolean;
}): string => {
  const value = query[paramKey];
  if (!value) return '';

  let targetIndex = 0;
  if (Array.isArray(value) && takeLast) {
    targetIndex = value.length - 1;
  }

  return Array.isArray(value) ? value[targetIndex] || '' : value || '';
};

/**
 * Get first value from string combined array
 */
export const getFirstValue = (query: string): string => {
  return query.split(',')[0];
};

/**
 * Extracts a string parameter from Next.js route params
 * Handles the string | string[] | undefined union type safely
 */
export const getStringParam = (param: string | string[] | undefined): string | null => {
  if (!param) return null;

  return Array.isArray(param) ? param[0] || null : param;
};
